import React, { FC } from 'react'
import styles from 'styles/components/label.module.scss'

const RequiredLabel: FC = () => {
  return <span className={styles.required}>必須</span>
}

export default RequiredLabel
